import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLgbtq = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 14.5,
				stroke: "#F44335",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 12.5,
				stroke: "#FF9800",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 10.5,
				stroke: "#FFEB3B",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 8.5,
				stroke: "#8BC34A",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 6.5,
				stroke: "#2196F3",
				strokeWidth: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 5,
				stroke: "#673AB7",
				strokeWidth: 2
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgLgbtq;
